import { render, staticRenderFns } from "./PoStatusBadge.vue?vue&type=template&id=bb850e16&scoped=true"
import script from "./PoStatusBadge.vue?vue&type=script&lang=js"
export * from "./PoStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./PoStatusBadge.vue?vue&type=style&index=0&id=bb850e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb850e16",
  null
  
)

export default component.exports